// extracted by mini-css-extract-plugin
export default {"wrapper":"price-page_wrapper__AZHHt"};